import { render, staticRenderFns } from "./ProjectChooseGeographicalLocationReadOnlyView.vue?vue&type=template&id=641d6fa7&scoped=true&"
import script from "./ProjectChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseGeographicalLocationReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChooseGeographicalLocationReadOnlyView.vue?vue&type=style&index=0&id=641d6fa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d6fa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
